import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Switch } from "../components/ui/switch";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { toast } from "sonner";

export default function Permissions() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/permissions").then((r) => setData(r.data)).catch(() => toast.error("Failed to load permissions"));
  useEffect(() => { load(); }, []);

  if (!data) return <p className="text-muted-foreground">Loading…</p>;

  const toggle = (k, v) => setData({ ...data, permissions: { ...data.permissions, [k]: v } });

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/permissions", { permissions: data.permissions });
      toast.success("Permissions saved — recorded in the audit log");
    } catch (e) {
      toast.error(apiError(e, "Save failed"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="permissions-page">
      <div>
        <h1 className="font-heading text-3xl font-bold">Permissions</h1>
        <p className="text-muted-foreground mt-1">
          Owner-only. These toggles control what the <strong>Manager</strong> role can do — the Owner always retains full access.
        </p>
      </div>
      <Card className="border-border shadow-none">
        <CardHeader><CardTitle className="font-heading text-lg">Manager capabilities</CardTitle></CardHeader>
        <CardContent className="space-y-1">
          {Object.entries(data.labels).map(([k, label]) => (
            <div key={k} className="flex items-center justify-between py-3 border-b last:border-0" data-testid={`perm-row-${k}`}>
              <div>
                <p className="text-sm font-medium">{label}</p>
                <p className="text-xs text-muted-foreground font-mono">{k}</p>
              </div>
              <Switch data-testid={`perm-toggle-${k}`} checked={!!data.permissions[k]} onCheckedChange={(v) => toggle(k, v)} />
            </div>
          ))}
        </CardContent>
      </Card>
      <Button onClick={save} disabled={saving} data-testid="permissions-save-btn" className="bg-primary hover:bg-[#8B5CF6] text-white">
        {saving ? "Saving…" : "Save permissions"}
      </Button>
    </div>
  );
}
